export default __webpack_public_path__ + "static/media/POTABLE.db6aa50d.svg";